// Marketplace categories — shared between Marketplace filter row and the
// Publish dialog's category picker. Order here is the order shown to users.
// "Suggested" is adverts-only and deliberately not listed here, so notes
// can never be published into it.
import {
  Utensils,      // food
  Plane,         // travel
  Dumbbell,      // fitness
  Palette,       // creations (id "assets")
  GraduationCap, // study
  House,         // home
  Shirt,         // clothes
  Hash,          // other
} from "lucide-react";

export const CATEGORIES = [
  { id: "food",    label: "Food",    Icon: Utensils },
  { id: "travel",  label: "Travel",  Icon: Plane },
  { id: "fitness", label: "Fitness", Icon: Dumbbell },
  { id: "assets",  label: "Creations", Icon: Palette },
  { id: "study",   label: "Study",   Icon: GraduationCap },
  { id: "home",    label: "Home",    Icon: House },
  { id: "clothes", label: "Clothes", Icon: Shirt },
  { id: "other",   label: "Other",   Icon: Hash },
];

export const CATEGORY_LABEL = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c.label])
);
